import { DocumentApi } from 'Api/Document/DocumentApi';
import { Button } from 'Components/Buttons/Buttons';
import { useCachedData } from 'Components/Context/CachedDataContext';
import { Modal } from 'Components/Modal/Modal';
import { ICON_CLOSE } from 'Config/Icons';
import { iso8601ToUsDateShort } from 'Helpers/DateTimeUtils/DateTimeUtils';
import { UserNameFormat, getUserNameFromSubject } from 'Helpers/UserUtils';
import { IssueHistoryResponse } from 'Models/Issues';

import { IssueDetailsSnapshot } from '../IssueDetailsSnapshot/IssueDetailsSnapshot';

export interface IssueHistoryModalProps {
    history: IssueHistoryResponse;
    documentApi: DocumentApi;
    hideModal: () => void;
}

/**
 * Renders a modal that displays a detailed historical snapshot of an issue. Matches the "main" section (containing current information) of the Issue Details page. Does not include information about impacted controls or third parties.
 */
export const IssueHistoryModal = (props: IssueHistoryModalProps) => {
    const cachedData = useCachedData();

    return (
        <Modal open header={props.history.issue.title} subHeader={`Last updated: ${iso8601ToUsDateShort(props.history.issue.last_updated_timestamp)} by ${getUserNameFromSubject(props.history.issue.last_updated_by, cachedData.users, UserNameFormat.FIRST_SPACE_LAST)}`}>
            <IssueDetailsSnapshot documentApi={props.documentApi} issueHistoryResponse={props.history} type="historical" />
            <div className={'modalFormButtonContainer'}>
                <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                    Close
                </Button>
            </div>
        </Modal>
    );
};
